import { Link } from 'react-router';
import { useAppSelector } from '@/app/hooks';
import { PATHS } from '@/app/paths';
import { Button } from '@/ui/button';

export function HomePage() {
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  return (
    <div className="flex min-h-svh flex-col bg-background text-foreground">
      <title>Tixbase</title>
      <header className="flex h-16.25 shrink-0 items-center px-4 md:px-8 lg:px-15">
        <img src="/brand/tixbase-logo.svg" alt="Tixbase" width={118} height={24} className="h-6 w-auto dark:hidden" />
        <img
          src="/brand/tixbase-logo-on-dark.svg"
          alt="Tixbase"
          width={118}
          height={24}
          className="hidden h-6 w-auto dark:block"
        />
      </header>

      <main className="flex flex-1 items-center justify-center px-4 py-8">
        <div className="flex w-full max-w-reading flex-col items-start gap-6">
          <h1 className="text-balance">Welcome to Tixbase</h1>
          <p className="text-pretty text-muted-foreground">
            The admin dashboard for your ticketing operations. Access is by invitation only.
          </p>
          <Button asChild variant="primary" size="pill-lg">
            <Link to={isAuthenticated ? PATHS.dashboard : PATHS.login}>
              {isAuthenticated ? 'Go to dashboard' : 'Sign in'}
            </Link>
          </Button>
        </div>
      </main>
    </div>
  );
}
